const countryCodes = [
    { code: "+93", country: "Afghanistan" },
    { code: "+61", country: "Australia" },
    { code: "+880", country: "Bangladesh" },
    { code: "+55", country: "Brazil" },
    { code: "+86", country: "China" },
    { code: "+20", country: "Egypt" },
    { code: "+33", country: "France" },
    { code: "+49", country: "Germany" },
    { code: "+852", country: "Hong Kong" },
    { code: "+91", country: "India" },
    { code: "+62", country: "Indonesia" },
    { code: "+98", country: "Iran" },
    { code: "+964", country: "Iraq" },
    { code: "+81", country: "Japan" },
    { code: "+60", country: "Malaysia" },
    { code: "+52", country: "Mexico" },
    { code: "+977", country: "Nepal" },
    { code: "+64", country: "New Zealand" },
    { code: "+92", country: "Pakistan" },
    { code: "+63", country: "Philippines" },
    { code: "+974", country: "Qatar" },
    { code: "+966", country: "Saudi Arabia" },
    { code: "+65", country: "Singapore" },
    { code: "+27", country: "South Africa" },
    { code: "+82", country: "South Korea" },
    { code: "+94", country: "Sri Lanka" },
    { code: "+971", country: "UAE" },
    { code: "+44", country: "United Kingdom" },
    { code: "+1", country: "United States" },
    { code: "+84", country: "Vietnam" },
];

const GuestDetails = ({
    isGuestEditMode,
    salutation,
    setSalutation,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    countryCode,
    setCountryCode,
    phone,
    setPhone,
    email,
    setEmail,
    address,
    setAddress,
    city,
    setCity,
    country,
    setCountry,
    state,
    setState,
    handleGuestEdit,
    handleGuestDone,
    handleGuestCancel,
}) => {
    return (
       <div className="card mb-4 shadow-sm border-0">
    <div className="card-header d-flex justify-content-between align-items-center bg-white py-3">
        <div className="d-flex align-items-center">
            <span className="material-symbols-outlined me-2 text-primary">
                person
            </span>
            <h6 className="mb-0">Guest Details</h6>
        </div>

        {!isGuestEditMode ? (
            <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={handleGuestEdit}
            >
                Edit
            </button>
        ) : (
            <div className="d-flex gap-2">
                <button
                    type="button"
                    className="btn btn-sm btn-success"
                    onClick={handleGuestDone}
                >
                    Done
                </button>
                <button
                    type="button"
                    className="btn btn-sm btn-secondary"
                    onClick={handleGuestCancel}
                >
                    Cancel
                </button>
            </div>
        )}
    </div>

    <div className="card-body">
        <div className="row g-4">

            {/* Salutation */}
            <div className="col-lg-1 col-md-3">
                <label className="text-muted small mb-2 d-block">
                    Salutation
                </label>

                {isGuestEditMode ? (
                    <select
                        className="form-select form-control"
                        value={salutation}
                        onChange={(e) => setSalutation(e.target.value)}
                    >
                        <option>Mr.</option>
                        <option>Ms.</option>
                        <option>Dr.</option>
                    </select>
                ) : (
                    <div className="fw-semibold">{salutation || "-"}</div>
                )}
            </div>

            {/* First Name */}
            <div className="col-lg-3 col-md-3">
                <label className="text-muted small mb-2 d-block">
                    First Name
                </label>

                {isGuestEditMode ? (
                    <input
                        className="form-control"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                    />
                ) : (
                    <div className="fw-semibold">{firstName || "-"}</div>
                )}
            </div>

            {/* Last Name */}
            <div className="col-lg-2 col-md-3">
                <label className="text-muted small mb-2 d-block">
                    Last Name
                </label>

                {isGuestEditMode ? (
                    <input
                        className="form-control"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                    />
                ) : (
                    <div className="fw-semibold">{lastName || "-"}</div>
                )}
            </div>

            {/* Phone */}
            <div className="col-lg-3 col-md-3">
                <label className="text-muted small mb-2 d-block">
                    Phone Number
                </label>

                {isGuestEditMode ? (
                    <div className="input-group">
                        <select
                            className="form-select"
                            style={{ maxWidth: "100px" }}
                            value={countryCode}
                            onChange={(e) => setCountryCode(e.target.value)}
                        >
                            {countryCodes.map((item) => (
                                <option key={item.code} value={item.code}>
                                    {item.code}
                                </option>
                            ))}
                        </select>

                        <input
                            className="form-control"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                    </div>
                ) : (
                    <div className="fw-semibold">
                        {countryCode} {phone || "-"}
                    </div>
                )}
            </div>

           

            {/* Country */}
            <div className="col-lg-2 col-md-6">
                <label className="text-muted small mb-2 d-block">
                    Country
                </label>

                {isGuestEditMode ? (
                    <input
                        className="form-control"
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                    />
                ) : (
                    <div className="fw-semibold">{country || "-"}</div>
                )}
            </div>

            {/* State */}
            <div className="col-lg-2 col-md-6">
                <label className="text-muted small mb-2 d-block">
                    State
                </label>

                {isGuestEditMode ? (
                    <input
                        className="form-control"
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                    />
                ) : (
                    <div className="fw-semibold">{state || "-"}</div>
                )}
            </div>

             {/* City */}
            <div className="col-lg-2 col-md-4">
                <label className="text-muted small mb-2 d-block">
                    City
                </label>

                {isGuestEditMode ? (
                    <input
                        className="form-control"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                    />
                ) : (
                    <div className="fw-semibold">{city || "-"}</div>
                )}
            </div>

            {/* Email */}
            <div className="col-lg-4 col-md-4">
                <label className="text-muted small mb-2 d-block">
                    Email
                </label>

                {isGuestEditMode ? (
                    <>
                        <input
                            className="form-control"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        <div className="form-check mt-2">
                            <input
                                className="form-check-input"
                                id="emailVoucher"
                                type="checkbox"
                            />
                            <label
                                className="form-check-label small"
                                htmlFor="emailVoucher"
                            >
                                Receive booking voucher on email
                            </label>
                        </div>
                    </>
                ) : (
                    <div className="fw-semibold">{email || "-"}</div>
                )}
            </div>

            {/* Address */}
            <div className="col-lg-4 col-md-4">
                <label className="text-muted small mb-2 d-block">
                    Address
                </label>

                {isGuestEditMode ? (
                    <textarea
                        rows={3}
                        className="form-control"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                    />
                ) : (
                    <div className="fw-semibold">{address || "-"}</div>
                )}
            </div>

            

        </div>
    </div>
</div>
    );
};

export default GuestDetails;